/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { MdAdd } from 'react-icons/md';

import PropTypes from 'prop-types';

import { Button } from '@material-ui/core';

import { VisuallyHiddenInput, Container } from './styles';

const file_types = {
    images: 'image/jpg, image/jpeg, image/png, image/gif',
    audios: 'audio/mpeg, audio/x-wav, audio/wav, audio/ogg',
    json: 'application/json',
    documents: 'application/pdf',
    // documents:  'application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document',
};

export default function FileInput({
    mode,
    defaultValue,
    onFileUpload,
    text,
    multiple,
    type,
    disabled,
    showIcon,
    showFooter,
}) {
    function renderCardInput() {
        return (
            <Container>
                <div className="jr-card jr-card-widget jr-card-full text-center card new-card">
                    <label htmlFor="file">
                        {defaultValue.id ? (
                            <div
                                className="label"
                                style={{
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                {type === 'images' ? (
                                    <img src={defaultValue.url} alt="" />
                                ) : (
                                    <div className="card-body text-center p-3">
                                        {defaultValue.name || ''}
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="card-body text-center">
                                {text}
                                {showIcon ? (
                                    <MdAdd
                                        size={48}
                                        style={{
                                            margin: '15px',
                                        }}
                                    />
                                ) : null}
                            </div>
                        )}
                        <input
                            type="file"
                            id="file"
                            accept={file_types[type]}
                            onChange={onFileUpload}
                            multiple={multiple}
                            disabled={disabled}
                        />
                        {showFooter && defaultValue && defaultValue.id ? (
                            <span>{text}</span>
                        ) : null}
                    </label>
                </div>
            </Container>
        );
    }

    function renderButtonInput() {
        return (
            <>
                <Button
                    component="label"
                    role={undefined}
                    variant="contained"
                    color="primary"
                    tabIndex={-1}
                    fullWidth
                >
                    <MdAdd
                        size={20}
                        style={{
                            color: '#fff',
                        }}
                    />
                    {text}
                    <VisuallyHiddenInput
                        type="file"
                        id="file"
                        accept={file_types[type]}
                        onChange={onFileUpload}
                        multiple={multiple}
                        disabled={disabled}
                    />
                </Button>
            </>
        );
    }

    return mode === 'button' ? renderButtonInput() : renderCardInput();
}

FileInput.propTypes = {
    defaultValue: PropTypes.object,
    onFileUpload: PropTypes.func.isRequired,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    disabled: PropTypes.bool,
    multiple: PropTypes.bool.isRequired,
    type: PropTypes.string,
    mode: PropTypes.string,
    showIcon: PropTypes.bool,
    showFooter: PropTypes.bool,
};

FileInput.defaultProps = {
    defaultValue: { id: null, url: null },
    disabled: false,
    type: 'images',
    text: '',
    showIcon: true,
    showFooter: true,
    mode: 'card',
};
